'use strict';

var React = require('react');

var SvgReferralCodeIcon = function SvgReferralCodeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.15 8.2c.202.269.55.364.85.257v3.043h-.25c-.414 0-.75.336-.75.75s.336.75.75.75h2c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-.25v-4c0-.824-.94-1.294-1.6-.8l-.6.45c-.331.249-.398.719-.15 1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6.5c-.967 0-1.75.784-1.75 1.75 0 .414.336.75.75.75s.75-.336.75-.75c0-.138.112-.25.25-.25s.25.112.25.25v.125c0 .255-.078.503-.222.712l-1.623 2.344c-.46.663.015 1.569.822 1.569h1.773c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-.819l1.08-1.56c.318-.46.489-1.005.489-1.565v-.125c0-.966-.784-1.75-1.75-1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.25c0-.414.336-.75.75-.75h1c.966 0 1.75.784 1.75 1.75v.247c0 .47-.163.907-.44 1.253.277.346.44.783.44 1.253v.247c0 .966-.784 1.75-1.75 1.75h-1c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1c.138 0 .25-.112.25-.25v-.247c0-.235-.163-.438-.392-.488l-.065-.015h-.293c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h.293l.066-.015c.228-.05.391-.253.391-.488v-.247c0-.138-.112-.25-.25-.25h-1c-.414 0-.75-.336-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 12c-.414 0-.75.336-.75.75s.336.75.75.75h2c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-2Z"
  }));
};
SvgReferralCodeIcon.displayName = "ReferralCodeIcon";

exports.SvgReferralCodeIcon = SvgReferralCodeIcon;
